import gql from 'graphql-tag';

import {
  AlbumRootAlbumFolderBaseDetails,
  AlbumWatermarkConfig,
  PhotoUrlTypeFields,
} from '../../../../graphql/fragments/album';
import { WebGalleryAccountDetailsWithImageAssets } from '../fragments/account';
import {
  WebGalleryAlbumBaseDetails,
  WebGalleryAlbumCustomPrintFields,
  WebGalleryAlbumPrices,
  WebGalleryAlbumPurchasedPhotoDownloads,
} from '../fragments/album';
import { PhotoAttribution } from '../fragments/global';
import { PhotoFavoriteDetails } from '../../../../graphql/fragments/photo';

export const AlbumPhotoGroupForWebGallery = gql`
  query albumPhotoGroupForWebGallery($id: RecordID!) {
    albumPhotoGroup(id: $id) {
      id
      name
      album {
        ...WebGalleryAlbumBaseDetails
        ...WebGalleryAlbumPurchasedPhotoDownloads
        ...WebGalleryAlbumPrices
        ...AlbumWatermarkConfig
        album_folder {
          id
          name
        }
        ...AlbumRootAlbumFolderBaseDetails
        creator {
          ...WebGalleryAccountDetailsWithImageAssets
        }
        ...WebGalleryAlbumCustomPrintFields
        videos {
          total
        }
      }
    }
  }
  ${AlbumWatermarkConfig}
  ${WebGalleryAlbumPrices}
  ${WebGalleryAlbumBaseDetails}
  ${AlbumRootAlbumFolderBaseDetails}
  ${WebGalleryAccountDetailsWithImageAssets}
  ${WebGalleryAlbumPurchasedPhotoDownloads}
  ${WebGalleryAlbumCustomPrintFields}
`;

export const AlbumPhotoGroupForWebGalleryPhotos = gql`
  query albumPhotoGroupForWebGalleryPhotos(
    $id: RecordID!
    $ignore_watermark: Boolean = true
    $limit: Int
    $offset: Int
    $for_web_gallery: Boolean
    $use_all_photos_mode: Boolean = false
  ) {
    albumPhotoGroup(id: $id) {
      id
      album {
        id
        ...WebGalleryAlbumCustomPrintFields
      }
      photos(
        include_unprocessed: false
        slice: { limit: $limit, offset: $offset }
        for_web_gallery: $for_web_gallery
        use_all_photos_mode: $use_all_photos_mode
      ) {
        total
        count
        records {
          id
          thumbnail_urls(ignore_watermark: $ignore_watermark) {
            ...PhotoUrlTypeFields
          }
          watermarked_urls {
            ...PhotoUrlTypeFields
          }
          ...PhotoAttribution
          share_blocked
          is_entitled_matched_photo
          is_owner
          ...PhotoFavoriteDetails
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
  ${PhotoAttribution}
  ${PhotoFavoriteDetails}
  ${WebGalleryAlbumCustomPrintFields}
`;
